@if(flowType == FLOW_TYPE.APPROVAL){
<p-timeline [value]="approvers">
    <ng-template pTemplate="content" let-approver>
        <div class="flex flex-col justify-between items-start !w-full">
            <div class="flex flex-row justify-between items-start !w-full">
                <div class="flex flex-row justify-between gap-2">
                    <div class="user-avatar">
                        @if(approver.type == USER_TYPE.INTERNAL){
                        <div class="relative user-avatar">
                            <!-- <img [src]="approver.user | userAvatar" alt="User Avatar" class="w-8 h-8 rounded-full" /> -->
                            @if(isUserUnverified(approver)){
                            <span
                                class="absolute top-3 left-2.5 w-6 h-6 flex items-center justify-center bg-gray-500 text-white rounded-full text-xs"
                                [pTooltip]="'Email Unverified'">
                                <i class="pi pi-exclamation-circle text-white text-sm"></i>
                            </span>
                            }
                        </div>
                        }
                    </div>
                    <div class="flex flex-col justify-between items-start">
                        <div class="flex flex-col">
                            <app-user-name-display [user]="approver.user" [fallbackText]="approver.name" [variant]="'avatar-name'">
                            </app-user-name-display>
                            <span [pTooltip]="isSmallScreen ? approver.email : ''" tooltipPosition="top"
                                class="text-gray-400 text-xs">
                                {{ isSmallScreen ? (approver.email | truncate:20) : approver.email }}
                            </span>
                        </div>
                        @if(approver.status === 'APPROVED'){
                        <span class="text-gray-400 text-xs">{{approver.modifiedAt | dateFormatter }}</span>
                        }
                        @if(approver.status === 'REJECTED'){
                        <span class="text-gray-400 text-xs">{{approver.modifiedAt | dateFormatter}}</span>
                        }
                    </div>
                </div>
                <div class="status">
                    <app-badge [approver]="approver"></app-badge>
                </div>

            </div>
            @if(approver.comments && approver.comments.length > 0){
            <p-accordion [multiple]="false" class="w-full">
                <p-accordion-panel value="0">
                    <p-accordion-header>
                        <div class="text-sm font-semibold flex items-center gap-2">
                            <i class="pi pi-comments"></i>
                            <span>Comments ({{ approver.comments.length }})</span>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <ng-container *ngIf="approver.comments?.length; else noComments">
                            <div *ngFor="let comment of approver.comments" class="flex items-center gap-2 py-1">
                                <i class="pi pi-comment text-gray-400 text-xs"></i>
                                <span class="text-gray-400 text-xs break-words whitespace-normal w-full">{{ comment
                                    }}</span>
                            </div>
                        </ng-container>
                        <ng-template #noComments>
                            <div class="text-gray-400 italic text-xs">{{"No comments yet." | textCase}}</div>
                        </ng-template>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
            }
        </div>
    </ng-template>
</p-timeline>
}@else {
    <p-timeline [value]="signatories">
        <ng-template pTemplate="content" let-signatory let-i="index">
            <div class="flex flex-row justify-between">
                <div class="flex flex-1 items-center gap-2">
                    <div class="relative">
                        @if(isUserUnverified(signatory) && signatory.type == USER_TYPE.INTERNAL){
                        <span
                            class="absolute -bottom-1 -right-1 w-4 h-4 flex items-center justify-center bg-gray-500 text-white rounded-full text-xs z-10"
                            [pTooltip]="'Email Unverified'">
                            <i class="pi pi-exclamation-circle text-white text-xs"></i>
                        </span>
                        }
                        <app-user-name-display 
                            [user]="signatory.user" 
                            [fallbackText]="signatory.name" 
                            [variant]="'avatar'">
                        </app-user-name-display>
                    </div>
    
                    <div class="flex flex-col">
                        <app-user-name-display 
                            [user]="signatory.user" 
                            [fallbackText]="signatory.name" 
                            [variant]="'name'">
                        </app-user-name-display>
    
                        <span [pTooltip]="isSmallScreen ? signatory.email : ''" tooltipPosition="top"
                            class="text-gray-400 text-xs">
                            {{ isSmallScreen ? (signatory.email | truncate:20) : signatory.email }}
                        </span>
    
                        @if(signatory.status === 'SIGNED' || signatory.status === 'REJECTED'){
                        <span class="text-gray-400 text-xs mt-0.5">
                            {{signatory.updatedAt | dateFormatter}}
                        </span>
                        }
                    </div>
                </div>
    
                <div class="items-center flex flex-row">
                    @if(signatory.signedAttachment){
                    <app-button icon="pi pi-download text-sm" variant="outlined" severity="contrast" toolTip="Download"
                        tooltipPosition="top" (clicked)="downloadSignedDocument(signatory)" />
                    }@else {
                    <app-badge [approver]="signatory"></app-badge>
                    }
                </div>
            </div>
        </ng-template>
    </p-timeline>
}